export const COPY_AMENITY = 'COPY_AMENITY';
export const VIEW_AMENITY = 'VIEW_AMENITY';
export const EDIT_AMENITY = 'EDIT_AMENITY';
export const ADD_AMENITY = 'ADD_AMENITY';